<template>
  <div class="table-box">
    <global-tag>
      <el-form label-width="100px">
        <el-row>
          <el-col :span="4">
            <el-form-item label="姓名：">
              <el-input
                placeholder="请输入"
                v-model="searchObj.customerName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="身份证号码：">
              <el-input
                clearable
                placeholder="请输入"
                v-model="searchObj.idCard"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="手机号码：">
              <el-input
                clearable
                placeholder="请输入"
                v-model="searchObj.phone"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="时间：">
              <el-date-picker
                v-model="searchObj.time"
                type="daterange"
                @change="chanegTime"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="所属机构:" prop="serviceStation">
              <el-select v-model="searchObj.serviceStation" placeholder="请选择" size="mini" filterable style="height:40px;line-height:40px;width: 100%">
                <el-option v-for="item in serviceStationList" :key="item.selectTreeId" :label="item.statName"
                  :value="item.selectTreeId">
                </el-option>
              </el-select>
            </el-form-item>
           </el-col>
           <el-col :span="4">
            <el-form-item label="所属类别:" prop="elderlyBelongCategory">
              <el-select
              v-model="searchObj.elderlyBelongCategory"
              placeholder="请选择"
              size="medium"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in oldtypeLits"
                :key="index"
                :label="item.dictLabel"
                :value="item.dictCode + ''"
              ></el-option>
            </el-select>
            </el-form-item>
           </el-col>
           <el-col :span="4">
            <el-form-item label="用户类型:" prop="customerType">
              <el-select
              v-model="searchObj.customerType"
              placeholder="请选择"
              class="overs"
              size="medium"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in userType"
                :key="index"
                :label="item.dictLabel"
                :value="item.dictCode"
              ></el-option>
            </el-select>
            </el-form-item>
           </el-col>
          <el-col :span="2" :offset="0">
            <el-button
              type="primary"
              class="searchBtns"
              @click="getTableData"
              style="margin-left: 20px"
              >查询
            </el-button>
          </el-col>
          <el-col :span="2">
            <el-button type="info" icon="el-icon-delete" @click="emptySearch"
              >清除条件</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </global-tag>
    <div class="ele-caozuo">
      <el-button
        type="success"
        size="medium"
        icon="el-icon-plus"
        class="openBtns"
        @click="handleTableForm('新增')"
        >新增
      </el-button>
      <el-button icon="el-icon-edit" type="info" @click="batchClear"
        >清除号码</el-button
      >
      <el-button
        icon="el-icon-finished"
        class="button"
        type="primary"
        style="margin-left: 10px; color: #fff"
        @click="dowmLoader"
        >下载模板
      </el-button>
      <el-upload
        :action="baseURL"
        multiple
        :on-success="handelSuccess"
        :on-change="handelChange"
        :file-list="fileList"
        :disabled="fileList.length > 0"
      >
        <el-button
          icon="el-icon-download"
          class="button"
          type="success"
          style="margin-left: 10px; color: #fff; padding: 12px 15px"
          @click="createInExcel"
          >导入
        </el-button>
      </el-upload>
      <el-button
        icon="el-icon-upload2"
        class="button downOutBtns"
        type="medium"
        style="margin-left: 10px; color: #fff"
        @click="createwayExcel"
        >导出</el-button
      >
      <el-button
        icon="el-icon-sell"
        class="button modelDownds"
        size="medium"
        type="primary"
        style="margin-left: 10px"
        @click="createExcel"
        >全部导出</el-button
      >
    </div>

    <div>
      <el-table
        :data="tableData"
        border
        style="width: 100%; margin-bottom: 15px"
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
          @selection-change="handleSelectionChange"
        >
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="70"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <!-- <el-table-column
             prop="fileNumber"
             label="档案号"
             align="center"
             :show-overflow-tooltip="true"
         >
         </el-table-column> -->
        <el-table-column
          prop="customerName"
          label="姓名"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="gender"
          label="性别"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ scope.row.gender == 1 ? "女" : "男" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="age"
          label="年龄"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系电话"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="customerTypeStr"
          label="用户类型"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="elderlyBelongCategory"
          label="所属类别"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-for="(item, index) in oldtypeLits" :key="index"
              ><span v-if="scope.row.elderlyBelongCategory == item.dictCode">{{
                item.dictLabel
              }}</span></span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="createName"
          label="创建人"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="220">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleTableForm('查看', scope.row.id)"
              >查看</el-button
            >
            <el-button
              type="text"
              @click="handleTableForm('编辑', scope.row.id)"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="deleteItem(scope.row.id)"
              style="margin-right: 15px"
              >删除</el-button
            >

            <el-popover placement="top-start" width="200" trigger="click">
              <slot>
                <vue-qr
                  ref="qr"
                  :text="String(scope.row.id)"
                  :size="200"
                ></vue-qr>
                <p
                  class="downCode"
                  @click="downloadImg(scope.$index, scope.row)"
                >
                  下载
                </p>
              </slot>
              <!-- @click="createCode(scope.row)" -->
              <el-button type="text" slot="reference">二维码</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageConfig.pageNo"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pageConfig.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageConfig.total"
      >
      </el-pagination>
    </div>

    <AddInfo
      v-if="showAddStatus"
      :setTitle="dialogTitle"
      :show-status.sync="showAddStatus"
      :formData="formData"
      @updateShowStatus="closeWindo"
    ></AddInfo>
    <!-- 清除手机号座机号 -->
    <el-dialog title="是否清除" width="300px" :visible.sync="dialogVisible6">
      <el-checkbox-group v-model="isphone">
        <el-checkbox label="清除手机号"></el-checkbox>
        <el-checkbox label="清除座机号"></el-checkbox>
      </el-checkbox-group>
      <div slot="footer">
        <el-button type="primary" @click="saveClear">确定</el-button>
        <el-button @click="Clears">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vueQr from "vue-qr"
import AddInfo from "./info/addInfo.vue"
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL.js"
import exportVue from "@/utils/exportVue"
export default {
  components: {
    AddInfo,
    vueQr,
  },
  data() {
    return {
      isSearchContent: true,
      searchObj: {},
      dialogTitle: "",
      showAddStatus: false,
      formData: {},
      tableData: [],
      oldtypeLits: [],
      // 分页
      pageConfig: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      vueQrText: "",
      oldData: {},
      dialogVisible6: false,
      isphone: [],
      selectedData: [],
      fileList: [],
      baseURL: baseURL + "/ypt/controller/uploadVotePic/info/uploadPartyVote",
      serviceStationList:[],
      userType:[]
    }
  },
  created() {
    this.getTableData()
    this.getTreeChecked()
    this.getusertypeList()
    let query = {
      pageNum: 1,
      pageSize: 999,
      dictType: "customer.type",
    }
    this.$http
      .request({
        url: "/rbac/system/dict/data/list",
        method: "get",
        params: query,
      })
      .then((res) => {
        if (res.code == 200) {
          if (res.rows != null) {
            this.oldtypeLits = res.rows
          }
        }
      })
  },
  inject: ["reload"], //注入
  methods: {
     //获取用户类型
     getusertypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "usertype",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.userType = res.rows
            }
          }
        })
    },
    getTreeChecked(id) {
      this.$http
        .request({
          url: "/jjyl/admin/serviceStation/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              return
            }
            this.serviceStationList = res.content.list.map((item) => {
              return {
                selectTreeId: item.id, //id
                statName: item.statName,
              }
            })
          }
        })
    },
    chanegTime(val) {
      this.searchObj.startTime = val[0]
      this.searchObj.endTime = val[1]
    },
    //清除
    emptySearch() {
      this.searchObj.customerName = ""
      this.searchObj.idCard = ""
      this.searchObj.phone = ""
      this.searchObj.time = ""
      this.searchObj.startTime = ""
      this.searchObj.endTime = ""
      this.searchObj.customerType = ""
      this.searchObj.elderlyBelongCategory = ""
      this.searchObj.serviceStation = ""
      this.getTableData()
    },
    // 下载模板
    dowmLoader() {
      this.request2({
        url: "/ypt/admin/all/customer/info/exportCustomerTemplate",
        data: {
          pageNo: 1,
          pageSize: 10,
        },
        method: "POST",
        responseType: "blob",
      }).then((res) => {
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "服务对象数据.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("下载成功")
        }
      })
    },
    // 导入
    createInExcel(e) {
      // console.log(e)
    },
    handelSuccess(e) {
      // console.log(e)
      if (this.fileList.length === 0) {
        this.$message.warning("请上传文件")
      } else {
        const data = new FormData()
        data.append("file", this.fileList[0].raw)
        // console.log(this.fileList)
        this.$http
          .request({
            headers: {
              "Content-Type": "multipart/form-data",
            },
            url: "/ypt/admin/all/customer/info/importingCustomer",
            data: data,
            method: "post",
          })
          .then((res) => {
            // console.log(res)
            if (res.code === 200) {
              this.$message({
                message: res.message,
                type: "success",
              })
              this.getTableData()
              this.fileList = []
            } else {
              this.$message({
                message: "数据导入失败",
                type: "warning",
              })
            }
          })
      }
    },
    // 导出
    async createwayExcel() {
      let ids = []
      if (this.selectedData.length > 0) {
        this.selectedData.forEach((item) => {
          ids.push(item.id)
        })
        const res = await this.request2({
          url: "/ypt/admin/all/customer/info/exportYptCustomer",
          method: "POST",
          data: {
            ids: ids,
          },
          responseType: "blob",
        })
        const blob = new Blob([res], {
          type: "application/vnd.ms-excel",
        })
        const fileName = "服务对象管理.xls"
        const linkNode = document.createElement("a")

        linkNode.download = fileName //a标签的download属性规定下载文件的名称
        linkNode.style.display = "none"
        linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
        document.body.appendChild(linkNode)
        linkNode.click() //模拟在按钮上的一次鼠标单击

        URL.revokeObjectURL(linkNode.href) // 释放URL 对象
        document.body.removeChild(linkNode)
        this.$refs.multipleTable.clearSelection()
      } else {
        this.$message.error("请选择服务对象")
      }
    },
    //全部导出
    createExcel() {
      this.request2({
        url: "/ypt/admin/all/customer/info/exportYptCustomer",
        method: "POST",
        excel: true,
        data: this.searchObj,
        responseType: "blob",
      }).then((res) => {
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "服务对象管理.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出表格成功")
        }
      })
    },
    handelChange(file, fileList) {
      this.fileList = fileList.slice(-3)
    },
    downloadImg(index, row) {
      let a = document.createElement("a")
      // 下载图名字
      a.download = row.customerName
      //url
      a.href = this.$refs.qr.$el.src
      //合成函数，执行下载
      a.dispatchEvent(new MouseEvent("click"))
    },
    Reset() {
      this.reload()
    },
    // 关闭系统
    closeWindo(state) {
      this.showAddStatus = false
      if (state == true) {
        this.getTableData()
      }
    },
    QuerySearch() {},
    handleSelectionChange(data) {
      this.selectedData = data
    },
    batchClear() {
      var that = this
      var val = this.selectedData
      if (val.length > 0) {
        this.dialogVisible6 = true
      } else {
        this.$confirm("请选择要清除的项。", "提示")
      }
    },
    saveClear() {
      var val = this.selectedData
      this.isphone.forEach((item) => {
        if (item == "清除手机号") {
          if (val.length > 0) {
            val.forEach(function (item, index) {
              request({
                url: "/ypt/admin/all/customer/info/updatePhone",
                method: "POST",
                data: { id: item.id },
              }).then((res) => {
                if (res.code == 200) {
                  this.$message.success("清除成功")
                }
              })
            })
          }
        }
        if (item == "清除座机号") {
          if (val.length > 0) {
            val.forEach(function (item, index) {
              request({
                url: "/ypt/admin/all/customer/info/updateFamilyCall",
                method: "POST",
                data: { id: item.id },
              }).then((res) => {
                if (res.code == 200) {
                  this.$message.success("清除成功")
                }
              })
            })
          }
        }
      })
      this.dialogVisible6 = false
      this.isphone = []
      this.getTableData()
    },
    Clears() {
      this.dialogVisible6 = false
      this.isphone = []
    },
    handleTableForm(title, id) {
      this.dialogTitle = title
      this.showAddStatus = true

      if (title != "新增") {
        this.$http
          .request({
            url: "/ypt/admin/all/customer/info/get",
            method: "POST",
            data: {
              id,
            },
          })
          .then((res) => {
            if (res.code === 200) {
              this.formData = res.content
              exportVue.$emit("warningId", this.formData.id)
            }
          })
      } else {
        this.formData = {}
      }
    },
    // 删除某一项
    deleteItem(id) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .request({
            url: "/ypt/admin/all/customer/info/deleteById",
            method: "POST",
            data: {
              id,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("删除成功")
              this.getTableData()
            }
          })
      })
    },
    getTableData() {
      this.$http
        .request({
          url: "/ypt/admin/all/customer/info/findList",
          method: "POST",
          data: {
            pageNo: this.pageConfig.pageNo,
            pageSize: this.pageConfig.pageSize,
            ...this.searchObj,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (!res.content) {
              this.tableData = []
              this.pageConfig.total = 0
            } else {
              this.tableData = res.content.list || []
              this.tableData.forEach((item) => {
                if (
                  item.customerTypeStr != null &&
                  item.customerTypeStr.indexOf("对象") == -1
                ) {
                  //没找到返回-1
                  item.customerTypeStr = ""
                }
              })
              this.pageConfig.total = res.content.count || 0
            }
          }
        })
    },
    // 每页显示条数切换
    handleSizeChange(val) {
      this.pageConfig.pageSize = val
      this.getTableData()
    },
    // 页码切换
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getTableData()
    },
  },
}
</script>

<style lang="less" scoped>
.ele-caozuo {
  width: 14%;
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
}

.operation-btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;
  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }
  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}
.searchDomw {
  cursor: pointer;
}

.downCode {
  text-align: center;
  cursor: pointer;
}
/deep/ .el-upload-list {
  display: none !important;
}
</style>
